import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractComponent} from "../abstract.component";
import {
  Competitor,
  ControlPointTime,
  Lookups,
  RaceSettings,
  WaypointType
} from "@model";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

interface MemberSection {
  member?: Competitor;
  controlTimes: ControlPointTime[];
  expanded: boolean;
  disableAll: boolean;
}

@Component({
  selector: 'app-delete-competitor-measurement-times',
  templateUrl: './delete-competitor-measurement-times.component.html',
  styleUrl: './delete-competitor-measurement-times.component.scss',
  standalone: false
})
export class DeleteCompetitorMeasurementTimes extends AbstractComponent implements OnInit {
  @Input({ required: true }) title: string = "";
  @Input() confirmButtonTitle?: string;
  @Input({ required: true }) competitor?: Competitor;
  @Input({ required: true }) forTeamMembers: boolean = false;
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() raceSettings: RaceSettings | undefined;

  @Output() onSave = new EventEmitter<Competitor>();

  saveEnabled: boolean = false;

  sections: MemberSection[] = [];

  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit(): void {
    this.sections = this.forTeamMembers
        ? (this.competitor?.teamMembers ?? []).map(member => ({
          member,
          controlTimes: this.buildControlTimes(member),
          expanded: true,
          disableAll: false,
        }))
        : [{
          member: undefined,
          controlTimes: this.buildControlTimes(this.competitor),
          expanded: true,
          disableAll: false,
        }];
  }

  private buildControlTimes(source: Competitor | undefined): ControlPointTime[] {
    return source?.controlPointsTimes?.filter(item => item.id).map(item => ({
      id: item.id,
      time: item.time ? new Date(item.time) : undefined,
      chipTime: item.chipTime ? new Date(item.chipTime) : undefined,
      controlWaypoint: item.controlWaypoint,
      lap: item.lap,
      penaltyMinutes: item.penaltyMinutes,
      selected: false
    })) || [];
  }


  toggleSection(section: MemberSection): void {
    section.expanded = !section.expanded;
  }

  onItemSelect(section: MemberSection, controlPointTime: ControlPointTime): void {
    const isStart = controlPointTime.controlWaypoint?.waypointTypeId === WaypointType.START_WAYPOINT;

    // Team members' START can't be cancelled from here
    if (isStart && this.forTeamMembers) {
      return;
    }

    if (isStart) {
      controlPointTime.selected = !controlPointTime.selected;
      section.controlTimes.forEach(ct => ct.selected = controlPointTime.selected);
      section.disableAll = controlPointTime.selected;
    } else if (!section.disableAll) {
      controlPointTime.selected = !controlPointTime.selected;
    }

    this.updateSaveEnabled();
  }

  private updateSaveEnabled(): void {
    this.saveEnabled = this.sections.some(section =>
        section.controlTimes.some(cpt => cpt.selected)
    );
  }

  onConfirmClick(): void {
    if (this.forTeamMembers) {
      this.sections.forEach(section => {
        if (section.member) {
          section.member.controlPointsTimes = section.controlTimes.filter(cpt => cpt.selected);
        }
      });
    } else if (this.competitor) {
      this.competitor.controlPointsTimes = this.sections[0]?.controlTimes.filter(cpt => cpt.selected);
    }
    this.onSave.emit(this.competitor);
  }

  onDismissClick(): void {
    this.activeModal.dismiss();
  }

  protected readonly WaypointType = WaypointType;
}